import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { WalletItemCombination } from "../../../store/common";
import * as httpClient from "../../../util/httpClient";
import { Notification } from "../../common/Notification";
import { useForm } from "react-hook-form";
import { getFlowByName } from "../../../config/FlowName";
import * as NextStepFlowAction from "../../../store/nextStepFlowService/actions";
import { ApplicationState } from "../../../store";
import { PropertySafetyFilled } from "@ant-design/icons";
import { useTranslation } from "react-i18next";
const CombinationDialog: React.FunctionComponent<{ requestDataCallback(): void; walletItem: WalletItemCombination; isNew: boolean; closeDialog(): void }> = (
    props
) => {
    const { t: tLang, i18n: i18nLang } = useTranslation();
    const [isLoading, setisLoading] = useState(false);

    const dispatch = useDispatch();
    const lostWalletFlow = useSelector((state: ApplicationState) => getFlowByName(state, "LOST-WALLET-ASSISTANCE"));
    const completeGetStartedItem = (flowID: any, flowName: string) => dispatch(NextStepFlowAction.actionCreators.completeGetStartedItem(flowID, flowName));
    const [combination, setCombination] = useState(props.walletItem);
    const [errorMsg, seterrorMsg] = useState("");
    const [hasError, setHasError] = useState(false);

    /**Validation with react-hook-form ***/
    const { register, errors, formState, handleSubmit } = useForm({
        mode: "onBlur",
        reValidateMode: "onChange",
    });

    const { isSubmitting } = formState;

    const closeDialog = () => {
        document.body.classList.remove("no_scroll");
        props.closeDialog();
    };

    const refresWalletItem = () => {
        closeDialog();
        props.requestDataCallback();
    };

    function onChnageHandler(event: any) {
        setHasError(false);
        const elName = event.currentTarget.name;
        setCombination({ ...combination, [elName as string]: event.currentTarget.value });
    }

    const saveItem = () => {
        const requestBody = {
            "lost-wallet": {
                "lost-wallet-combination": combination,
            },
        };
        setisLoading(true);
        httpClient
            .sendRequest("POST", "api/lostWallet/" + (props.isNew ? "addNewWalletItem" : "updateWalletItem"), requestBody)
            .then((data) => {
                setisLoading(false);
                if (data.isSuccess) {
                    if (lostWalletFlow && lostWalletFlow.flowStepStatus !== "COMPLETED") {
                        completeGetStartedItem(lostWalletFlow.flowStepId, lostWalletFlow.flowName ? lostWalletFlow.flowName : " ");
                    }
                    Notification({
                        type: "success",
                        title: props.isNew
                            ? tLang("identityVault.secureStorage.lostWallterWidget.combination.addToastTitle")
                            : tLang("identityVault.secureStorage.lostWallterWidget.combination.updateToastTitle"),
                        message: props.isNew
                            ? tLang("identityVault.secureStorage.lostWallterWidget.combination.addToastMessage")
                            : tLang("identityVault.secureStorage.lostWallterWidget.combination.updateToastMessage"),
                    });
                    refresWalletItem();
                } else if (data.hasError && data.errors.length > 0) {
                    seterrorMsg(data.errors.join(", "));
                    setHasError(true);
                } else {
                    seterrorMsg(tLang("identityVault.secureStorage.lostWallterWidget.combination.unknownError"));
                    setHasError(true);
                }
            })
            .catch(function (error) {
                setisLoading(false);
                Notification({
                    type: "error",
                    title: tLang("identityVault.secureStorage.lostWallterWidget.combination.errorToastTitle"),
                    message: tLang("identityVault.secureStorage.lostWallterWidget.combination.errorToastMesage"),
                    duration: 0,
                });
                closeDialog();
            });
    };

    return (
        <React.Fragment>
            {!isLoading ? (
                <>
                    <div className="dialog-header">
                        <div className="dialog-icon">
                            <em className={props.isNew ? "las la-plus" : "las la-edit"}></em>
                        </div>
                        <h1>
                            {props.isNew
                                ? tLang("identityVault.secureStorage.lostWallterWidget.combination.addLabel")
                                : tLang("identityVault.secureStorage.lostWallterWidget.combination.editLabel")}{" "}
                            {tLang("identityVault.secureStorage.lostWallterWidget.combination.title")}
                        </h1>
                    </div>
                    <form onSubmit={handleSubmit(saveItem)} id="combination-form-container">
                        <div className="dialog-body">
                            <div className={errors["itemName"] ? "form-row row status-error" : "form-row row"}>
                                <div className="form-row inline row">
                                    <div className="form-label col-xs-12 col-sm-4 col-no-gutter">
                                        <label htmlFor="edit-item-name">
                                            {tLang("identityVault.secureStorage.lostWallterWidget.combination.label.nameOfItem")}{" "}
                                            <span className="required" title="Mandatory">
                                                *
                                            </span>
                                        </label>
                                    </div>
                                    <div role="alert" className="form-input col-xs-12 col-sm-8 col-no-gutter">
                                        <input
                                            aria-required="true"
                                            type="text"
                                            className="inputbox"
                                            id="edit-item-name"
                                            aria-labelledby="edit-item-name"
                                            name="itemName"
                                            defaultValue={combination.itemName}
                                            onChange={onChnageHandler}
                                            ref={register({
                                                required: true,
                                            })}
                                            maxLength={30}
                                        />
                                        {errors.itemName && errors.itemName.type === "required" && (
                                            <span className="form-error">
                                                {tLang("identityVault.secureStorage.lostWallterWidget.combination.validationMessage.name.required")}
                                            </span>
                                        )}
                                    </div>
                                </div>
                            </div>

                            <div className={errors["itemCombination"] ? "form-row row status-error" : "form-row row"}>
                                <div className="form-row inline row">
                                    <div className="form-label col-xs-12 col-sm-4 col-no-gutter">
                                        <label htmlFor="edit-combination">
                                            {tLang("identityVault.secureStorage.lostWallterWidget.combination.label.combination")}{" "}
                                            <span className="required" title="Mandatory">
                                                *
                                            </span>
                                        </label>
                                    </div>
                                    <div role="alert" className="form-input col-xs-12 col-sm-8 col-no-gutter">
                                        <input
                                            aria-required="true"
                                            type="text"
                                            className="inputbox"
                                            id="edit-combination"
                                            aria-labelledby="edit-combination"
                                            name="itemCombination"
                                            defaultValue={combination.itemCombination}
                                            onChange={onChnageHandler}
                                            ref={register({
                                                required: true,
                                            })}
                                            maxLength={30}
                                        />
                                        {errors.itemCombination && errors.itemCombination.type === "required" && (
                                            <span className="form-error">
                                                {tLang("identityVault.secureStorage.lostWallterWidget.combination.validationMessage.combination.required")}
                                            </span>
                                        )}
                                    </div>
                                </div>
                            </div>

                            <div className="form-row inline row">
                                <div className="form-label col-xs-12 col-sm-4 col-no-gutter">
                                    <label htmlFor="edit-location-of-item">
                                        {tLang("identityVault.secureStorage.lostWallterWidget.combination.label.location")}
                                    </label>
                                </div>
                                <div className="form-input col-xs-12 col-sm-8 col-no-gutter">
                                    <input
                                        type="text"
                                        className="inputbox"
                                        id="edit-location-of-item"
                                        aria-labelledby="edit-location-of-item"
                                        maxLength={30}
                                        name="itemLocation"
                                        defaultValue={combination.itemLocation}
                                        onChange={onChnageHandler}
                                    />
                                </div>
                            </div>

                            <div className="form-row inline row">
                                <div className="form-label col-xs-12 col-sm-4 col-no-gutter">
                                    <label htmlFor="edit-location-of-key">{tLang("identityVault.secureStorage.lostWallterWidget.combination.label.key")}</label>
                                </div>
                                <div className="form-input col-xs-12 col-sm-8 col-no-gutter">
                                    <input
                                        type="text"
                                        className="inputbox"
                                        id="edit-location-of-key"
                                        aria-labelledby="edit-location-of-key"
                                        maxLength={30}
                                        name="keyLocation"
                                        defaultValue={combination.keyLocation}
                                        onChange={onChnageHandler}
                                    />
                                </div>
                            </div>

                            <div className="form-row inline row">
                                <div className="form-label col-xs-12 col-sm-4 col-no-gutter">
                                    <label htmlFor="edit-notes">{tLang("identityVault.secureStorage.lostWallterWidget.combination.label.notes")}</label>
                                </div>
                                <div className="form-input col-xs-12 col-sm-8 col-no-gutter">
                                    <textarea
                                        className="inputbox"
                                        id="edit-notes"
                                        name="notes"
                                        aria-labelledby="edit-notes"
                                        maxLength={500}
                                        style={{ resize: "none" }}
                                        placeholder=""
                                        rows={6}
                                        defaultValue={combination.notes}
                                        onChange={onChnageHandler}
                                    ></textarea>
                                </div>
                            </div>

                            {hasError && (
                                <div className="form-row inline row">
                                    <div className="form-label col-xs-12 col-sm-4 col-no-gutter"></div>
                                    <div className="form-input col-xs-12 col-sm-8 col-no-gutter">
                                        <p className="form-error">{errorMsg}</p>
                                    </div>
                                </div>
                            )}
                        </div>

                        <div className="dialog-footer">
                            <div className="row between-xs">
                                <div className="col-xs col-no-gutter flex-grow-null">
                                    <button type="button" className="btn-default btn-link btn-no-padding btn-no-border" onClick={() => closeDialog()}>
                                        <span className="btn-text">
                                            {tLang("identityVault.secureStorage.lostWallterWidget.combination.label.cancelButtonText")}
                                        </span>
                                    </button>
                                </div>
                                <div className="col-xs col-no-gutter flex-grow-null">
                                    <button type="submit" className="btn-default btn-primary" disabled={isSubmitting}>
                                        <span className="btn-text">{tLang("identityVault.secureStorage.lostWallterWidget.combination.label.saveButtonText")}</span>
                                    </button>
                                </div>
                            </div>
                        </div>
                    </form>
                </>
            ) : (
                <div className="box loading"></div>
            )}
        </React.Fragment>
    );
};

export default CombinationDialog;
